exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "scaling-policy-summary .alarm-name {\n  word-break: break-all;\n}\nscaling-policy-summary .actions {\n  font-size: 85%;\n  margin: 0 0 15px 0;\n  border-bottom: 1px solid var(--color-alto);\n}\nscaling-policy-summary .actions .btn-left {\n  padding-left: 0;\n  border-left-width: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/scalingPolicySummary.component.less
// module id = 3468
// module chunks = 0